import { updateListMethod } from '../../utils/list'
import { 
  ROLES_UPDATE_LIST,
  ROLES_UPDATE_LIST_METHOD
} from '../actions/role.actions'

const initState = {
  list: []
}

const roleReducer = (state = initState, action) => {
  const newState = { ...state }
  const { type, payload } = action
  switch (type) {
    case ROLES_UPDATE_LIST:
      newState.list = payload.list
    break
    case ROLES_UPDATE_LIST_METHOD:
      newState.list = updateListMethod(payload.method, payload.data, newState.list)
    break
    default:
      break
  }

  return newState
}

export default roleReducer
